import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import { carColors } from "../../../../Enums/Fixed";
import PhoneInput from "react-phone-input-2";
import ZoneService from "../../../../../services/ZoneService";

const AddQuickValetModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		client_phone: "",
		vehicle_number: "",
		vehicle_color: "",
		brand_model: "",
		zone: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [zonesOptions, setZonesOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		Service.getZones().then((res) => {
			if (res?.status) {
				const respons = res?.data?.data?.map((zone) => {
					return {
						...zone,
						label: lang === "en" ? zone?.zone?.name_en : zone?.zone?.name_ar,
						value: zone?.zone_id,
					};
				});
				setZonesOptions(respons);
				if (Object.keys(item)?.length === 0) {
					setIsAdd(true);
				} else {
					setIsAdd(false);
					setFormData({
						id: item?.id,
						client_phone: item?.client_phone || "",
						brand_model: item?.brand_model || "",
						vehicle_number: item?.vehicle_number || "",
						vehicle_color:
							carColors?.find((res) => res?.value === item?.vehicle_color) ||
							"",
						zone: respons?.find((zone) => zone?.value === item?.zone_id),
					});
				}
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.zone) {
			toast.error("Select Zone");
			return;
		}
		let data = {
			zone_id: formData?.zone?.value,
		};
		if (!!formData?.client_phone) data["client_phone"] = formData?.client_phone;
		if (!!formData?.vehicle_number)
			data["vehicle_number"] = formData?.vehicle_number;
		if (!!formData?.vehicle_color)
			data["vehicle_color"] = formData?.vehicle_color?.value;
		if (!!formData?.brand_model) data["brand_model"] = formData?.brand_model;

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addQuick" : "ar fade addQuick"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.quick_valet}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						<Col md={6} className="mb-3">
							<label className="text-label">{Translate[lang]?.zone}</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								options={zonesOptions}
								onChange={(e) => setFormData({ ...formData, zone: e })}
							/>
						</Col>
						{/* Phone */}
						<Col md={6} className="mb-3">
							<label>{Translate[lang]?.phone}</label>
							<PhoneInput
								country={"kw"}
								className="w-100"
								enableSearch={true}
								value={formData?.client_phone}
								onChange={(e) => setFormData({ ...formData, client_phone: e })}
							/>
						</Col>
						{/* Vehicle Number */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.vehicle_number}
								type="text"
								placeholder={Translate[lang]?.vehicle_number}
								name="vehicle_number"
								bsSize="lg"
								// validate={{
								// 	required: {
								// 		value: true,
								// 		errorMessage: Translate[lang].field_required,
								// 	},
								// }}
								value={formData.vehicle_number}
								onChange={(e) =>
									setFormData({ ...formData, vehicle_number: e.target.value })
								}
							/>
						</Col>
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.vehicle_color}
							</label>
							<Select
								value={formData?.vehicle_color}
								name="vehicle_color"
								placeholder={Translate[lang]?.select}
								options={carColors}
								onChange={(e) => setFormData({ ...formData, vehicle_color: e })}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.brand_model}
								type="text"
								placeholder={Translate[lang]?.brand_model}
								bsSize="lg"
								name="brand_model"
								// validate={{
								// 	required: {
								// 		value: true,
								// 		errorMessage: Translate[lang].field_required,
								// 	},
								// }}
								value={formData.brand_model}
								onChange={(e) =>
									setFormData({ ...formData, brand_model: e.target.value })
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{Translate[lang]?.start_time}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddQuickValetModal;
